import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { IGetAllProductResponse } from "model";
import { ProductActions } from "redux/actions";

interface IProductState extends IBaseReducerState {
  products?: IGetAllProductResponse;
}

const initialState: IProductState = {
  action: ProductActions.prefix,
  prefix: ProductActions.prefix,
};

const getAllProductsSuccessfully = (
  state: IProductState,
  action: PayloadAction<IGetAllProductResponse>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.products = action.payload;
  });

const clearReducer = (state: IProductState, action: PayloadAction) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.products = undefined;
    state.action = ProductActions.prefix;
  });

const UserReducer = ReduxHelper.createHandleReducer<IProductState>(
  initialState,
  (builder) => {
    builder
      .addCase(
        ProductActions.getAllProducts.success,
        getAllProductsSuccessfully
      )
      .addCase(ProductActions.clearReducer.request, clearReducer);
  }
);

export default UserReducer;
